import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import PeriodFilterSelect from './PeriodFilterSelect';
import styles from './detail.scoped.css';
import {
  MONTH_OPTIONS,
  buildYearOptions,
  clampMonthToCurrentYear,
  formatMonthFilterDisplayLabel,
} from './utils/historyDateTime';

export default function HistoryMonthYearFilter({
  month,
  onMonthChange,
  onYearChange,
  year,
}) {
  const currentDate = dayjs();
  const currentYear = currentDate.format('YYYY');
  const currentMonth = currentDate.format('MM');
  const yearOptions = useMemo(() => buildYearOptions(Number(currentYear)), [currentYear]);

  const disabledMonthValues = useMemo(() => {
    if (year !== currentYear) {
      return [];
    }

    return MONTH_OPTIONS.filter((option) => option.value > currentMonth).map(
      (option) => option.value
    );
  }, [currentMonth, currentYear, year]);

  const handleYearChange = (nextYear) => {
    onYearChange(nextYear);
    onMonthChange(clampMonthToCurrentYear(month, nextYear, currentDate));
  };

  const monthDisplayValue = useMemo(
    () => formatMonthFilterDisplayLabel(month, year, currentDate),
    [currentMonth, currentYear, month, year]
  );

  return (
    <div className={styles.historyFilterFields}>
      <PeriodFilterSelect
        className={styles.monthFilterField}
        disabledValues={disabledMonthValues}
        displayValue={monthDisplayValue}
        label="Bulan"
        onChange={onMonthChange}
        options={MONTH_OPTIONS}
        placeholder="Pilih bulan"
        value={month}
      />
      <PeriodFilterSelect
        className={styles.yearFilterField}
        label="Tahun"
        onChange={handleYearChange}
        options={yearOptions}
        placeholder="Pilih tahun"
        value={year}
      />
    </div>
  );
}

HistoryMonthYearFilter.propTypes = {
  month: PropTypes.string.isRequired,
  onMonthChange: PropTypes.func.isRequired,
  onYearChange: PropTypes.func.isRequired,
  year: PropTypes.string.isRequired,
};
